import { Flex, Input } from '@chakra-ui/react'
import Clean from '../../../components/Clean'
import { listModifier } from '../storage'

export default function FiltersModifier() {
    const { clear, ...props } = listModifier.useSearch()

    return (
        <Flex>
            <Clean value={props.value} onClick={clear}>
                <Input w="80" placeholder="🏸 Buscar por nombre" {...props} />
            </Clean>
        </Flex>
    )
}
